import React from "react";
import { Form } from "react-bootstrap";
import CommonConstants from "../../constants/CommonConstants";

const InputForm = ({
  value,
  placeholder,
  isDisabled,
  textArea,
  onChange,
  ...rest
}) => {
  return (
    <>
      {textArea ? (
        <Form.Control
          placeholder={placeholder}
          value={value}
          disabled={isDisabled}
          autoComplete={CommonConstants.autoCompleteInput}
          onChange={onChange}
          as="textarea"
          rows={2}
          {...rest}
        />
      ) : (
        <Form.Control
          placeholder={placeholder}
          value={value}
          autoComplete={CommonConstants.autoCompleteInput}
          disabled={isDisabled}
          onChange={onChange}
          size="md"
          {...rest}
        />
      )}
    </>
  );
};

export default InputForm;
